import { render, staticRenderFns } from "./InventoryListSalePricing.vue?vue&type=template&id=6bc5ca70&"
import script from "./InventoryListSalePricing.vue?vue&type=script&lang=js&"
export * from "./InventoryListSalePricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports